// icons
import React, { useEffect, useRef, useState } from "react";
import styles from "./styles/eventDetail.module.scss";
import { API_ROUTES } from "@/services/environment";
import { Bartender, Booking, EventNote } from "./Interface";
import { useAppSelector } from "@/hooks/hook";
import { DELETE, GET, PATCH, POST } from "@/services/api";
import TimerList from "@/constants/TimerList";
import { toDate, toZonedTime } from "date-fns-tz";
import { format } from "date-fns";
import { CrossIcon, DeleteIcon } from "@/utils/svgs";
import useLoading from "@/hooks/useLoading";
import Alert from "@/components/alert/Alert";
import { EVENT_TYPE_DATA } from "@/constants/Events";
import addIcon from "../../assets/icons/addIcon.svg";
import { COCKTAILS_TYPES_DATA } from "@/constants/CompanyData";
import { FiEdit2 } from "react-icons/fi";
import FormModal from "@/components/modals/FormModal";
import { RiCircleFill } from "react-icons/ri";
import checkedOrange from "../../assets/icons/checkedOrange.svg";
import { AiFillPlusCircle } from "react-icons/ai";
import ScrollToTop from "@/components/ScrollToTop";
import { createPartiallyEmittedExpression } from "typescript";
import { Button, Loader, USFormatePriceWithDecimal } from "@thdinc/hpf-shared";
import checkBox from "../../assets/images/check.png";
const forPack = ["water", "seltzer", "beer"];
import { GoPlus } from "react-icons/go";
import { calculateEstimatedDrinks, fmt } from "@/helpers/quoteFunctions";
import { CocktailProviders, TypeOfServiceOptions } from "../Quote/constants/Options";
import { centsToDollors, diffMinutesAllowNextDay, splitEventDateAndTime } from "@/helpers/TimeFormat";
import CustomBartenderModal from "../Bartender/CustomBatenderModal";
import userDefaultImg from "@/assets/images/defaultuser.jpg";
import { Drinker } from "../Quote/components/Drinker";

interface BookingDetailInterface {
    bookingId: string;
    rerender: boolean;
    setRerender: (value: boolean) => void;
}

interface User {
    first_name: string;
    last_name: string;
    roles: string;
    // Add other properties of the user object if available
}

export const QuoteEventDetailPage: React.FC<BookingDetailInterface> = ({
    bookingId,
    rerender,
    setRerender,
}) => {
    const {
        getEventDetailApi,
        updateBookingBartendersApi,
        getEventNotesApi,
        addEventNoteApi,
        deleteEventNodeApi,
        updateEventNoteApi,
        customerBartenders,
    } = API_ROUTES;

    const GUESTS_PER_BARTENDER = 75;
    const { refreshToken } = useAppSelector((store) => store.user);
    //  const user = useAppSelector((store)=> store.user)

    const textareaRef = useRef<HTMLTextAreaElement | null>(null);
    const { isLoading, startLoading, stopLoading } = useLoading();
    const [isFetching, setIsFetching] = useState(false);
    const [products, setProducts] = useState<any[]>([]);
    const [numberOfCocktailes, setNumberOfCocktailes] = useState<number>();
    const [booking, setBooking] = useState<Booking | null>(null);
    const [selectedBarts, setSelectedBarts] = useState<Bartender[]>([]);
    const [showForm, setShowForm] = useState(false);
    const [noteText, setNoteText] = useState("");
    const [noteList, setNoteList] = useState<EventNote[]>([]);
    const [formState, setFormState] = useState<string>("Add");
    const [noteId, setNoteId] = useState<string>("");
    const canSelectBart =
        booking && 12 <= getNumberOfHours(new Date(), booking?.start_time);
    const [listOfBarts, setListOfBarts] = useState<Bartender[]>([]);
    const [customBartenderIds, setCustomBartenderIds] = useState<Set<string>>(new Set());
    const guests = Number(booking?.guests) || 0;
    const requiredBartenders = Math.max(1, Math.ceil(guests / GUESTS_PER_BARTENDER));
    const bartenderPackageCompany = booking?.bookingQuoteBartenderPackage?.
        filter((item: any) => item?.provider == 'companyProvide');
    const bartenderPackageCustomer = booking?.bookingQuoteBartenderPackage?.
        filter((item: any) => item?.provider != 'companyProvide');
    const cocktailCompany = booking?.bookingQuoteCocktails?.
        filter((item: any) => item?.provider == 'store-provide' || item?.provider == 'business-provide') || [];
    const cocktailCustomer = booking?.bookingQuoteCocktails?.
        filter((item: any) => item?.provider == 'customer-provide') || [];
    const cocktailHoProvide = booking?.bookingQuoteCocktails?.
        filter((item: any) => item?.provider == 'ho-provide') || [];
    // const selectOrRemoveBart = (id: string) => {
    //   if (selectedBarts.includes(id)) {
    //     const filtered = selectedBarts?.filter((item: string) => item !== id);
    //     setSelectedBarts(filtered);
    //   } else {
    //     if(selectedBarts.length <shouldSelect  )
    //     setSelectedBarts([...selectedBarts, id]);
    //   }
    // };
    const removeBart = (id: string) => {
        setSelectedBarts((prev) => prev.filter((item) => item.id !== id));
    };
    const addBart = (id: string) => {
        if (selectedBarts.some((b) => b.id === id)) return;
        const bart = listOfBarts.find((item: Bartender) => item.id === id);
        if (bart) setSelectedBarts((prev) => [...prev, bart]);
    };

    /** Merge assigned + available + custom bartenders; dedupe by id */
    const mergeBartenderLists = (
        assigned: Bartender[],
        available: Bartender[],
        custom: Bartender[] = []
    ): Bartender[] => {
        const byId = new Map<string, Bartender>();
        for (const b of assigned) if (b?.id) byId.set(b.id, b);
        for (const b of available) if (b?.id && !byId.has(b.id)) byId.set(b.id, b);
        for (const b of custom) if (b?.id && !byId.has(b.id)) byId.set(b.id, b);
        return Array.from(byId.values());
    };

    /** Map custom-bartender/list API item to Bartender */
    const mapCustomBartender = (raw: Record<string, unknown>): Bartender | null => {
        const id = raw?.id ?? raw?.user_id ?? raw?._id;
        if (id == null) return null;
        const first = (raw.first_name ?? raw.firstName ?? "") as string;
        const last = (raw.last_name ?? raw.lastName ?? "") as string;
        const avatar = (raw.avatar ?? raw.image ?? "") as string;
        return {
            id: String(id),
            first_name: first,
            last_name: last,
            avatar: avatar || userDefaultImg,
        };
    };
    const startTime =
        booking && booking?.start_time
            ? splitEventDateAndTime(booking.start_time).formattedTime
            : new Date().toString();
    const endTime =
        booking && booking?.end_time
            ? splitEventDateAndTime(booking.end_time).formattedTime
            : new Date().toString();

    // get booking detail + custom bartenders — listOfBarts = assigned + available + custom
    useEffect(() => {
        const getBookingDetail = async () => {
            try {
                setIsFetching(true);
                const result = await GET(
                    `${getEventDetailApi}/${bookingId}`,
                    refreshToken
                );
                if (result.data.success) {
                    const data = result.data.data;
                    setBooking(data);
                    const assigned = (data?.bartenders ?? []) as Bartender[];
                    const available = (data?.quoteBookingAvailableBartenders ??
                        data?.quoteBookingAvailanleBartenders ??
                        []) as Bartender[];

                    let customBarts: Bartender[] = [];
                    try {
                        const customRes = await GET(
                            `${customerBartenders}/list`,
                            refreshToken
                        );
                        const body = customRes?.data;
                        const arr = Array.isArray(body?.rows)
                            ? body.rows
                            : Array.isArray(body?.data)
                                ? body.data
                                : Array.isArray(body?.list)
                                    ? body.list
                                    : Array.isArray(body)
                                        ? body
                                        : [];
                        customBarts = arr
                            .map((item: Record<string, unknown>) => mapCustomBartender(item))
                            .filter((b: Bartender | null): b is Bartender => b != null);
                    } catch {
                        // custom list optional
                    }

                    setListOfBarts(mergeBartenderLists(assigned, available, customBarts));
                    setCustomBartenderIds(new Set(customBarts.map((b) => b.id)));
                    setSelectedBarts(assigned);
                }
            } catch (error) {
                console.log("Error fetching booking details:", error);
            } finally {
                setIsFetching(false);
            }
        };
        getBookingDetail();
    }, [bookingId, rerender]);
    useEffect(() => {
        if (booking) {
            const numberOfHours = getNumberOfHours(
                booking.start_time,
                booking.end_time
            );
            const numberOfCocktails = Math.ceil(booking.guests * (numberOfHours + 1));
            setNumberOfCocktailes(numberOfCocktails);

            //
            const mergedProducts: any = [];
            booking.products.forEach((item: any) => {
                let existingProduct = mergedProducts.find(
                    (product: any) => product.productid === item.productid
                );
                if (existingProduct) {
                    existingProduct = {
                        ...existingProduct,
                        quantity:
                            parseInt(existingProduct.quantity) + parseInt(item.quantity),
                    };
                    const index = mergedProducts.findIndex(
                        (product: any) => product.product.id === item.product.id
                    );
                    mergedProducts[index] = existingProduct;
                } else {
                    mergedProducts.push({
                        ...item,
                        product: { ...item.product },
                    });
                }
            });
            setProducts(mergedProducts);
        }
    }, [booking]);
    // get notes
    useEffect(() => {
        const getNotesFun = async () => {
            try {
                const res = await GET(`${getEventNotesApi}/${bookingId}`, refreshToken);
                setNoteList(res.data);
            } catch (error) {
                console.log(error);
            }
        };
        if (booking) {
            getNotesFun();
        }
    }, [booking]);
    const inputRef = useRef<HTMLTextAreaElement>(null);
    // Focus on the input when the dropdown opens
    useEffect(() => {
        if (showForm && inputRef.current) {
            inputRef.current.focus();
        }
    }, [showForm]);
    const updateBartender = async () => {
        try {
            startLoading();
            const res = await POST(
                `${updateBookingBartendersApi} `,
                {
                    bookingId: booking?.id,
                    bartenderId: selectedBarts.map((item: Bartender) => item.id),
                },
                refreshToken
            );
            if (res.data.success) {
                setRerender(!rerender);
                Alert({ message: res?.data?.message });
            }
        } catch (error) {
            console.log(error);
            Alert({ type: "error", message: "Something went wrong" });
        } finally {
            stopLoading();
        }
    };
    const [isModalOpen, setIsModalOpen] = useState(false);
    const addUpdateNoteFun = async () => {
        try {
            let response: any;
            if (noteText !== "") {
                if (formState === "Add") {
                    response = await POST(
                        addEventNoteApi + "/" + bookingId,
                        { note: noteText, businessId: booking?.business.id },
                        refreshToken
                    );
                } else {
                    response = await PATCH(
                        updateEventNoteApi + "/" + noteId,
                        { note: noteText, bookingId, businessId: booking?.business.id },
                        refreshToken
                    );
                }
                if (response.data.success) {
                    Alert({ message: response?.data?.message });
                    setShowForm(false);
                    setNoteText("");
                    if (formState === "Add") {
                        setNoteList([...noteList, { ...response?.data?.data }]);
                    } else {
                        setNoteList(
                            noteList.map((note: EventNote) => {
                                if (note.id === noteId) {
                                    return response?.data?.data;
                                }
                                return note;
                            })
                        );
                    }
                }
            } else {
                Alert({ type: "error", message: `Note can't be empty` });
            }
        } catch (error) {
            console.log(error);
        }
    };
    const deleteNoteFun = async (noteId: string) => {
        try {
            const response = await DELETE(
                deleteEventNodeApi + "/" + noteId,
                refreshToken
            );
            if (response?.data?.success) {
                Alert({ message: response?.data?.message });
                const filtered = noteList.filter(
                    (note: EventNote) => note.id !== noteId
                );
                setNoteList(filtered);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const openModal = () => setIsModalOpen(true);
    const closeModal = () => {
        setIsModalOpen(false);
    };
    const rerenderFun = () => {
        setRerender(!rerender);
    };
    // const productListWithCocktail = booking?.products && booking.products.length > 0 ? booking.products : [];
    // const productList = productListWithCocktail.filter((item:any) => item.cocktailId);
    // const allZero = productList.length > 0 && productList.every((item: any) => item.isbtcprovide == false);
    // const allGreaterThanZero = productList.length > 0 && productList.every((item: any) => item.isbtcprovide);
    // const mixed = productList.length > 0 && !allZero && !allGreaterThanZero;
    // const isalcoholProvideByBrtenderCompany = productList.length > 0 && (allGreaterThanZero || mixed);
    // const isalcoholArrangeByCustomer = productList.length > 0 && (allZero || mixed);
    const isAlcoholFn = (productList: any) => {
        const cocktailAlcohol = productList?.filter((i: any) => i.cocktailid);
        const isalcoholProvideByBrtenderCompany =
            cocktailAlcohol?.length > 0 &&
            cocktailAlcohol?.filter((item: any) => item.isbtcprovide)?.length > 0;
        const isalcoholArrangeByCustomer =
            cocktailAlcohol?.length > 0 &&
            cocktailAlcohol?.filter((item: any) => item.isbtcprovide == false)
                ?.length > 0;
        return {
            bartenderProvideAlcohol: isalcoholProvideByBrtenderCompany,
            customerProvideAlcohol: isalcoholArrangeByCustomer,
        };
    };
    const alcoholStatus = isAlcoholFn(booking?.products);
    function getNumberOfBartenders(guests: number, guestsPerBartender: number) {
        return Math.ceil(guests / guestsPerBartender);
    }
    const [guestsByPackageSelection, setGuestsByPackageSelection] =
        useState<number>(0);
    const mandatoryAddons =
        booking?.addons?.filter((item: any) => item.is_btc_edit === false) || [];
    const nonMandatoryAddons =
        booking?.addons?.filter((item: any) => item.is_btc_edit == true) || [];
    const bartenderProvideAddons = mandatoryAddons
        .filter((item: any) => item.is_btc_provide === true)
        .concat(nonMandatoryAddons);
    const customerProvideAddons = mandatoryAddons.filter(
        (item: any) => item.is_btc_provide === false
    );
    const estDrinks = () => {
        let precomputedEstDrinks: number | '' = '';
        try {
            const guests = Number(booking?.guests) || 0;
            const startTimeStr = booking?.start_time
                ? splitEventDateAndTime(booking.start_time).formattedTime
                : '';
            const endTimeStr = booking?.end_time
                ? splitEventDateAndTime(booking.end_time).formattedTime
                : '';
            const drinkerType = booking?.drinker_type as Drinker | undefined;
            if (guests > 0 && startTimeStr && endTimeStr && drinkerType) {
                const eventLengthHours = Math.ceil(
                    diffMinutesAllowNextDay(startTimeStr, endTimeStr) / 60,
                );
                precomputedEstDrinks = calculateEstimatedDrinks(guests, drinkerType, eventLengthHours)
            }
        } catch {
            precomputedEstDrinks = '';
        }
        return precomputedEstDrinks;
    }
    useEffect(() => {
        if (booking) {
            const guestsPerBartenderCustom =
                booking.iscocktail == false &&
                    booking.isbeer == false &&
                    booking.iswine == false
                    ? booking?.package?.guests_per_bartender
                    : booking.iscocktail == true
                        ? booking?.package?.guests_per_bartender
                        : booking?.package?.guests_per_beer;
            const guestsPerBartender =
                booking?.package?.type == "custom_package"
                    ? guestsPerBartenderCustom
                    : booking?.package?.guests_per_bartender;

            setGuestsByPackageSelection(guestsPerBartender);
        }
    }, [booking]);

    return (
        <section className={`${styles.container}`}>
            <ScrollToTop />
            {!isFetching ? (
                <>
                    <div className="mt-3 ">
                        {/* <Button  onClick={downloadPdf}>Download</Button> */}
                    </div>

                    {booking ? (
                        <div className="flex gap-8 md:flex-row flex-col">
                            {/* Left */}
                            <div className="flex flex-col gap-7 md:w-8/12 ">
                                {/*Bartenders Assigned: */}
                                {/* Show when there are assigned and/or available pool bartenders to pick from */}
                                {booking && listOfBarts.length > 0 && (
                                    <div
                                        className={`bg-white p-5 rounded-xl ${booking.auto_selected ? "border border-primary-red" : ""
                                            }`}
                                    >
                                        <div>
                                            {/* <img
                    src={brtnderImg}
                    width={35}
                    height={35}
                    alt="Happiest Ours"
                  /> */}
                                            <div className="flex justify-between  mb-4 sm:mb-3 ">
                                                <div className="flex items-center gap-2 sm:gap-3 flex-wrap">
                                                    <p className="text-2xl font-semibold ">Bartenders</p>
                                                    {booking.auto_selected ? (
                                                        <div className="bg-[#fcd7d4] px-3  py-1 rounded-full  ">
                                                            <p className="text-[#FF6100] text-xs font-bold">
                                                                {" "}
                                                                Unassigned
                                                            </p>
                                                        </div>
                                                    ) : (
                                                        <div className="bg-[#ccf0eb] px-3  py-1 rounded-full">
                                                            <p className="text-[#00B69B] text-xs font-bold">
                                                                Assigned
                                                            </p>
                                                        </div>
                                                    )}
                                                </div>

                                                <p className=" my-2 font-medium bg-p-gray rounded-full px-3 py-2 text-xs text-center sm:text-start">
                                                    {requiredBartenders === 1
                                                        ? "Select 1 bartender"
                                                        : `Select ${requiredBartenders} bartenders (75 guests per bartender)`}
                                                </p>
                                            </div>

                                            {/* <p className={styles.fontBold}>Add-ons:</p> */}

                                            <div className="flex gap-5 flex-wrap justify-center sm:justify-start">
                                                {listOfBarts.map((item: Bartender, i) => {
                                                    return (
                                                        <div
                                                            onClick={() => {
                                                                if (canSelectBart) {
                                                                    if (
                                                                        selectedBarts
                                                                            .map((i) => i.id)
                                                                            .includes(item.id)
                                                                    ) {
                                                                        removeBart(item.id);
                                                                    } else {
                                                                        if (
                                                                            // shouldSelect > selectedBarts.length &&
                                                                            canSelectBart
                                                                        ) {
                                                                            addBart(item.id);
                                                                        }
                                                                    }
                                                                }
                                                            }}
                                                            key={i}
                                                            className={`flex flex-col gap-2 items-center cursor-pointer `}
                                                        >
                                                            <div className="relative">
                                                                <img
                                                                    className={`w-[114px] h-[114px]   object-cover rounded-xl ${selectedBarts
                                                                        .map((i) => i.id)
                                                                        .includes(item.id) &&
                                                                        "border-orange-500 border-4  "
                                                                        } `}
                                                                    src={item.avatar || userDefaultImg}
                                                                    alt=""
                                                                />
                                                                {selectedBarts
                                                                    .map((i) => i.id)
                                                                    .includes(item.id) && (
                                                                        <img
                                                                            src={checkedOrange}
                                                                            className="absolute top-2 right-2"
                                                                        />
                                                                    )}
                                                                {customBartenderIds.has(item.id) && (
                                                                    <span className="absolute bottom-1 left-1 right-1 text-center text-[10px] font-semibold text-white/95 bg-black/40 backdrop-blur-sm px-2 py-0.5 rounded-md border border-white/20">
                                                                        Custom
                                                                    </span>
                                                                )}
                                                            </div>
                                                            <div className="text-center">
                                                                <p className="text-sm font-semibold">
                                                                    <span className=" rounded-full bg-primary-red w-1 h-3 inline-block mr-2"></span>
                                                                    {item.first_name + " " + item.last_name}{" "}
                                                                </p>
                                                                {/* <div
                              className="cursor-pointer"
                              onClick={() => removeBart(item.id)}
                            >
                              {canSelectBart && <DeleteIcon />}
                            </div> */}
                                                            </div>
                                                        </div>
                                                    );
                                                })}
                                                {/* <div
                                                    onClick={openModal}
                                                    className={`flex w-[114px] h-[114px]  flex-col items-center justify-center gap-3 cursor-pointer bg-[#F4F4F4] rounded-xl p-2`}>
                                                    <div>
                                                        <GoPlus className="w-5 h-5 text-black opacity-40" />
                                                    </div>
                                                    <div>
                                                        <p className="text-xs text-black opacity-40">
                                                            Custom bartender
                                                        </p>
                                                    </div>
                                                </div> */}
                                            </div>
                                            <FormModal
                                                overflow="overflow-hidden "
                                                modalTitle="Add Bartender"
                                                isOpen={isModalOpen}
                                                width="lg:w-3/6 md:w-5/6 w-full"
                                                height="overflow-y-auto"
                                                onClose={closeModal}
                                            >
                                                <CustomBartenderModal
                                                    closeModal={closeModal}
                                                    rerenderFun={rerenderFun}
                                                    booking={booking}
                                                />
                                                {/* <AddBartenderModal
                                                    closeModal={closeModal}
                                                    rerenderFun={rerenderFun}
                                                /> */}
                                            </FormModal>

                                            {canSelectBart && (
                                                <div className="text-end">
                                                    <Button
                                                        onClick={updateBartender}
                                                        disabled={isLoading || selectedBarts.length < requiredBartenders}
                                                        classes={`  ${selectedBarts.length >= requiredBartenders
                                                            ? "bg-primary-red hover:bg-prtimary-red-button-hover text-white  "
                                                            : "bg-gray-300 text-gray-500"
                                                            }   px-6 bg-[#ff5100]  `}
                                                    >
                                                        {" "}
                                                        {isLoading ? <Loader color="bg-gray-50" /> : "Save"}
                                                    </Button>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {/* Card */}
                                <div className="bg-white p-5 rounded-xl overflow-x-auto">
                                    <div className="flex justify-between items-center">
                                        <p className="text-2xl font-semibold ">Event Overview</p>
                                        {/* Tags */}
                                        <div className="flex gap-2 flex-wrap">
                                            <div className="flex gap-1 bg-p-gray rounded-full py-2 px-4 text-xs font-semibold tracking-wider ">
                                                <p>Type:</p>
                                                <p className="">
                                                    {" "}
                                                    {EVENT_TYPE_DATA &&
                                                        EVENT_TYPE_DATA.find(
                                                            (a: any) => a.value === booking?.eventtype
                                                        )?.name}
                                                </p>
                                            </div>
                                            <div className="flex gap-1 bg-p-gray rounded-full py-2 px-4 text-xs font-semibold tracking-wider ">
                                                <p>Venue:</p>
                                                <p className="capitalize"> {booking?.eventsite}</p>
                                            </div>
                                            {booking?.type_of_service && (
                                                <div className="flex gap-1 bg-p-gray rounded-full py-2 px-4 text-xs font-semibold tracking-wider ">
                                                    <p>Type of Service:</p>
                                                    <p className="capitalize"> {TypeOfServiceOptions.find((o) => o.value === booking?.type_of_service)?.name}</p>
                                                </div>
                                            )}
                                            {/* <div className="flex gap-1 bg-p-gray rounded-full py-2 px-4 text-xs font-semibold tracking-wider ">
                                                <p>Tip:</p>
                                                <p className="capitalize">
                                                    {" "}
                                                    {booking?.tips ? "Yes" : "No"}
                                                </p>
                                            </div> */}
                                        </div>
                                    </div>
                                    <div className="flex flex-col gap-5 mt-4">
                                        {/* section */}
                                        {/* Col */}
                                        <div className="flex flex-col gap-1">
                                            <h1 className="flex items-center gap-2 text-lg font-semibold">
                                                <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                                                Client Details
                                            </h1>
                                            {/* row */}
                                            <div className="ml-3 flex gap-3 mt-2 text-[15px]">
                                                <p className="font-semibold">Client: </p>
                                                <p className="text-gray-600 ">
                                                    {booking?.first_name + " " + booking?.last_name}
                                                </p>
                                            </div>
                                            {/* row */}
                                            <div className="ml-3  flex gap-3  text-[15px] ">
                                                <p className="font-semibold">Phone: </p>
                                                <p>{booking && booking?.phone}</p>
                                            </div>
                                            {/* row */}
                                            <div className="ml-3  flex gap-3  text-[15px] ">
                                                <p className="font-semibold">Email: </p>
                                                <p>{booking && booking?.email}</p>
                                            </div>
                                            {/* row */}
                                            <div className="ml-3  flex gap-3  text-[15px] ">
                                                <p className="font-semibold">Address: </p>
                                                <p>
                                                    {booking &&
                                                        booking?.address1 +
                                                        ", " +
                                                        booking.city +
                                                        ", " +
                                                        booking.state +
                                                        ", " +
                                                        booking.postalcode}
                                                </p>
                                            </div>
                                        </div>
                                        {/* section */}
                                        {/* Col */}
                                        <div className="flex flex-col gap-1 mt-3">
                                            <h1 className="flex items-center gap-2 text-lg font-semibold">
                                                <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                                                Event Details
                                            </h1>

                                            {/* row */}
                                            <div className="ml-3 flex gap-3 mt-2  text-[15px]">
                                                <p className="font-semibold">Date: </p>
                                                <p className="text-gray-600">
                                                    {booking &&
                                                        format(new Date(booking?.start_time), "MM-dd-yyyy")}
                                                </p>
                                            </div>
                                            {/* row */}
                                            <div className="ml-3  flex gap-3  text-[15px]">
                                                <p className="font-semibold">Time: </p>
                                                <p>{startTime + " - " + endTime}</p>
                                            </div>
                                            <div className="ml-3  flex gap-2  text-[15px]">
                                                <p className="font-semibold">Guests: </p>
                                                <p>{booking?.guests}</p>
                                            </div>
                                            {/* <div className="ml-3  flex gap-2  text-[15px]">
                                                <p className="font-semibold">Drinking Pace: </p>
                                                <p> {booking?.drinker_type === "light" ? "Light"
                                                    : booking?.drinker_type === "medium"
                                                        ? "Standard"
                                                        : booking?.drinker_type === "heavy"
                                                            ? "Party"
                                                            : ""}</p>
                                            </div> */}
                                            <div className="ml-3  flex gap-2  text-[15px]">
                                                <p className="font-semibold">Estimated Drinks: </p>
                                                <p> {estDrinks()}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Cocktails & Ingredients: */}
                                <div className=' bg-white border border-gray-200 rounded-2xl p-6'>
                                    {/* Header */}
                                    <h2 className='text-xl font-semibold text-gray-900 mb-4'>Provisional Invoice</h2>
                                    {(bartenderPackageCompany && bartenderPackageCustomer) && <div>
                                        {/* Sub-header */}
                                        <h3 className='text-base font-semibold text-gray-800 mb-4'>
                                            Bartending Package Details
                                        </h3>
                                        {bartenderPackageCompany.length > 0 && <div>
                                            {/* Table */}
                                            <div className='overflow-x-auto'>
                                                <table className='w-full text-sm text-left text-gray-700 border-t border-gray-200'>
                                                    <thead className='text-gray-500 text-xs uppercase border-b border-gray-200'>
                                                        <tr>
                                                            <th className='px-4 py-3 font-medium'>Item Detail</th>
                                                            <th className='px-4 py-3 font-medium text-center'>Quantity</th>
                                                            <th className='px-4 py-3 font-medium text-center'>Rate</th>
                                                            <th className='px-4 py-3 font-medium text-right'>Amount</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {bartenderPackageCompany?.map((item: any, index: any) => {
                                                            return (
                                                                <tr className='border-b border-gray-100' key={index}>
                                                                    <td className='px-4 py-3 font-medium'>{item?.name ?? '-'}</td>
                                                                    <td className='px-4 py-3 text-center'>{item?.quantity ?? '-'}</td>
                                                                    <td className='px-4 py-3 text-center'>${item?.pricePerItem ? (item?.pricePerItem / 100).toFixed(2) : '-'}</td>
                                                                    <td className='px-4 py-3 text-right'>${item?.lineTotal ? (item?.lineTotal / 100).toFixed(2) : '-'}</td>
                                                                </tr>
                                                            )
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                            {/* Summary */}
                                            <div className="mt-6 grid grid-cols-2 gap-4  w-full">
                                                <div className="w-full">{/* LEFT COLUMN */}</div>
                                                <div className="text-sm w-full">
                                                    {/* RIGHT COLUMN */}
                                                    <Row label="Subtotal" value={fmt(centsToDollors(booking?.package_total))} />
                                                    <Row label="Tips" value={fmt(centsToDollors(booking?.tips_total))} />
                                                    <Row label="HOT Platform Fee" value={fmt(centsToDollors(booking?.service_fees))} />
                                                    {booking?.discount_total ? (<Row label="Discount" value={`-${fmt(centsToDollors(booking?.discount_total))}`} />) : <></>}
                                                    <div className="mt-3 flex items-center justify-between border-t pt-3 border-gray-200">
                                                        <span className="text-sm font-medium text-gray-700">Total</span>
                                                        <span className="text-lg font-semibold text-gray-900">
                                                            {fmt(centsToDollors(booking?.service_total + booking?.tips_total))}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>}
                                        {/* Customer Provides */}
                                        {bartenderPackageCustomer.length > 0 &&
                                            <div className="mt-6 rounded-2xl bg-gray-50 p-4">
                                                <p className="text-sm text-gray-800 mb-3 text-[10px] font-[600]">
                                                    Client Provides
                                                </p>
                                                <div className="flex flex-wrap gap-2">
                                                    {bartenderPackageCustomer.map((item: any, i: any) => (
                                                        <span
                                                            key={i}
                                                            className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-sm"
                                                        >
                                                            <span className="text-[10px]">{item?.name}</span>
                                                            {/* <span className="inline-flex h-6 items-center px-2 text-[10px] text-[#8D8D8D] ">
                                                                {item?.quantity}
                                                            </span> */}
                                                        </span>
                                                    ))}
                                                </div>
                                            </div>}
                                    </div>}
                                    {/* Estimated Alcohol Details */}
                                    {(cocktailCustomer || cocktailHoProvide || cocktailCompany) && <div>
                                        {/* Header */}
                                        <h2 className='text-xl font-semibold text-gray-700 mb-4 mt-8'>Alcohol Details</h2>
                                        {/* Table */}
                                        {
                                            booking?.max_estimated_alcohol ? (<>
                                                <div className='overflow-x-auto'>
                                                    <table className='w-full text-sm text-left text-gray-700 border-t border-gray-200'>
                                                        <thead className='text-gray-500 text-xs uppercase border-b border-gray-200'>
                                                            <tr>
                                                                <th className='px-4 py-3 font-medium'>Item Detail</th>
                                                                <th className='px-4 py-3 font-medium'>Cocktail</th>
                                                                <th className='px-4 py-3 font-medium'>Description</th>
                                                                <th className='px-4 py-3 font-medium text-center'>Quantity</th>
                                                                <th className='px-4 py-3 font-medium text-center'>Rate</th>
                                                                <th className='px-4 py-3 font-medium text-right'>Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {cocktailCompany.length > 0 && cocktailCompany.map((item: any) => (
                                                                <tr key={item?.id} className='border-b border-gray-100'>
                                                                    <td className='px-4 py-3 font-medium'>{
                                                                        CocktailProviders.find(
                                                                            (provider) => provider.value === item?.provider
                                                                        )?.name ?? null
                                                                    }</td>
                                                                    <td className='px-4 py-3'>{item?.cocktailName ?? '-'}</td>
                                                                    <td className='px-4 py-3'>{item?.brandName ?? '-'}</td>
                                                                    <td className='px-4 py-3 text-center'>{item?.quantity ?? '-'}</td>
                                                                    <td className='px-4 py-3 text-center'>${item?.pricePerItem ? (item?.pricePerItem / 100).toFixed(2) : '-'}</td>
                                                                    <td className='px-4 py-3 text-right font-medium'>${((Number(item?.pricePerItem) * Number(item?.quantity)) / 100).toFixed(2)}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <div className="mt-6 grid grid-cols-2 gap-4  w-full ">
                                                    <div className="w-full">{/* LEFT COLUMN */}</div>
                                                    <div className="text-sm w-full">
                                                        {/* RIGHT COLUMN */}
                                                        <Row label="Alcohol Subtotal" value={fmt(centsToDollors(booking?.max_estimated_alcohol))} />
                                                        <Row label="Sales Tax" value={fmt(centsToDollors(booking?.max_estimated_alcohol * 0.10))} />
                                                        <div className="mt-3 flex items-center justify-between border-t pt-3 border-gray-200">
                                                            <span className="text-sm font-medium text-gray-700">Total:</span>
                                                            <span className="text-lg font-semibold text-gray-900">
                                                                {fmt(centsToDollors(booking?.max_estimated_alcohol + booking?.max_estimated_alcohol * 0.10))}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>) : <></>
                                        }
                                        {/* <div className="flex items-center gap-2 mt-4">
                                                    <InfoIcon className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
                                                    <p className="text-gray-400 text-xs">
                                                        This may not be the final alcohol charge. If preferred brands are selected we will charge based off of the bottles used after the event. If preferred brands are not selected then each bottle is final sale.
                                                    </p>
                                                </div> */}
                                        {/* Customer Provides */}
                                        {cocktailCustomer.length > 0 && <div className="mt-6 rounded-2xl bg-gray-50 p-4">
                                            <p className="text-sm text-gray-800 mb-3 text-[10px] font-[600]">
                                                Client Provides
                                            </p>
                                            <div className="flex flex-wrap gap-2">
                                                {cocktailCustomer.map((item: any) => (
                                                    <span
                                                        key={item?.id}
                                                        className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-sm"
                                                    >
                                                        <span className="text-[10px]">{item?.brandName ?? '-'}:</span>
                                                        <span className="inline-flex h-6 items-center px-2 text-[10px] text-[#8D8D8D] ">
                                                            {item?.quantity ?? '-'}
                                                        </span>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>}
                                        {/* Selling Cocktails */}
                                        {cocktailHoProvide.length > 0 && <div className="mt-6 rounded-2xl bg-gray-50 p-4">
                                            <p className="text-sm text-gray-800 mb-3 text-[10px] font-[600]">
                                                Selling Cocktails
                                            </p>
                                            <div className="flex flex-wrap gap-2">
                                                {cocktailHoProvide.map((item: any) => (
                                                    <span
                                                        key={item?.id}
                                                        className="inline-flex items-center gap-2 rounded-full bg-white px-3 py-1.5 text-sm"
                                                    >
                                                        <span className="text-[10px]">{item?.brandName ?? '-'}:</span>
                                                        <span className="inline-flex h-6 items-center px-2 text-[10px] text-[#8D8D8D] ">
                                                            {item?.quantity ?? '-'}
                                                        </span>
                                                    </span>
                                                ))}
                                            </div>
                                        </div>}
                                    </div>}
                                    {/* Addtional Information*/}
                                    {/* Header */}
                                    <h2 className='text-xl font-semibold text-gray-900 mb-2 mt-4'>Addtional Information</h2>
                                    {/* Sub-header */}
                                    <h3 className=' text-gray-400 text-xs max-h-[300px] overflow-y-auto pr-2 whitespace-pre-wrap break-words'>
                                        {booking?.notes}
                                    </h3>
                                </div>
                                {/* Company Details */}
                                <div className="bg-white p-5 rounded-xl flex flex-col gap-6 overflow-hidden ">
                                    <p className="text-2xl font-semibold ">Company Details</p>
                                    <div className="flex gap-2 flex-col sm:flex-row">
                                        <img
                                            src={booking?.business?.logo || ""}
                                            alt="Business image"
                                            className="w-28 h-28 object-cover rounded-md"
                                        />
                                        <div className="flex flex-col text-[15px]">
                                            <p className="font-semibold text-lg ">
                                                {" "}
                                                {booking?.business?.name}
                                            </p>
                                            <div className="flex gap-3 mt-2 ">
                                                <p className="font-semibold">Phone: </p>
                                                <p className="text-gray-600">
                                                    {booking?.business?.phone_number}
                                                </p>
                                            </div>
                                            <div className=" flex gap-3 ">
                                                <p className="font-semibold">Email: </p>
                                                <p className="text-gray-600">
                                                    {booking?.business?.email}
                                                </p>
                                            </div>
                                            <div className=" flex gap-3 ">
                                                <p className="font-semibold">Address: </p>
                                                <p className="text-gray-600">
                                                    {booking?.business?.address1}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* Right section */}
                            <div className="flex flex-col  md:w-5/12  gap-7">
                                <div className=" bg-white px-5 pb-4 rounded-xl  relative overflow-y-auto">
                                    <div className="flex justify-between items-center py-2 bg-white sticky left-2 right-2 top-0">
                                        <p className="text-2xl font-semibold ">Additional Notes</p>
                                        <div
                                            onClick={() => {
                                                setFormState("Add");
                                                setNoteText("");
                                                setShowForm(!showForm);
                                            }}
                                            className=" inline-block  rounded-full cursor-pointer"
                                        >
                                            {/* <img src={addIcon} width={15} height={15} /> */}
                                            <AiFillPlusCircle
                                                className="text-primary-red"
                                                size={25}
                                            />
                                        </div>
                                    </div>
                                    {/* Add or adit form */}
                                    <FormModal
                                        modalTitle="Add Note"
                                        width="w-full md:w-[550px]"
                                        isOpen={showForm}
                                        onClose={() => setShowForm(false)}
                                    >
                                        <textarea
                                            ref={inputRef}
                                            rows={5}
                                            value={noteText}
                                            onChange={(e) => setNoteText(e.target.value)}
                                            className=" w-full  p-3 bg-p-gray rounded-xl    focus:outline-none  focus:ring-1 focus:ring-primary-red  text-gray-600"
                                            name=""
                                            id=""
                                        ></textarea>
                                        <div className="text-end">
                                            <Button
                                                classes={`  ${noteText.length > 0
                                                    ? "bg-primary-red hover:bg-primary-red-button-hover text-white  "
                                                    : "bg-gray-300 text-gray-500"
                                                    }   px-6 bg-[#ff5100]  `}
                                                onClick={addUpdateNoteFun}
                                            >
                                                {formState === "Add" ? "Add" : "Update"}
                                            </Button>
                                        </div>
                                    </FormModal>
                                    {/* Notes list */}
                                    <div className="flex flex-col max-h-80 mt-3">
                                        {/* Notes card */}
                                        {noteList.length > 0 &&
                                            noteList?.map((data: EventNote) => {
                                                const { id, date, note, created_by, modified_by } =
                                                    data;
                                                return (
                                                    <div
                                                        key={id}
                                                        className="bg-p-gray p-3 rounded-xl mt-4"
                                                    >
                                                        <div className="flex justify-between ">
                                                            <div className=" group  flex gap-2">
                                                                <p className="flex items-center gap-2  font-semibold">
                                                                    <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                                                                    Added By:
                                                                </p>
                                                                <p className=" text-gray-500">{created_by}</p>
                                                            </div>

                                                            <div className="flex gap-2 items-center  ">
                                                                <div
                                                                    className="cursor-pointer"
                                                                    onClick={() => {
                                                                        setFormState("Update");
                                                                        setShowForm(true);
                                                                        setNoteText(note);
                                                                        setNoteId(id);
                                                                    }}
                                                                >
                                                                    <FiEdit2 size={14} />
                                                                </div>
                                                                <div
                                                                    className=" cursor-pointer"
                                                                    onClick={() => deleteNoteFun(id)}
                                                                >
                                                                    <DeleteIcon />
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {modified_by && (
                                                            <div className=" group  flex gap-2">
                                                                <p className="flex items-center gap-2  font-semibold">
                                                                    <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                                                                    Modified By:
                                                                </p>
                                                                <p className=" text-gray-500">{modified_by}</p>
                                                            </div>
                                                        )}
                                                        <div className="flex gap-2 ">
                                                            <p className="flex items-center gap-2  font-semibold">
                                                                <span className=" rounded-full bg-primary-red w-1 h-3 inline-block"></span>{" "}
                                                                Date:
                                                            </p>
                                                            <p className=" text-gray-500">
                                                                {" "}
                                                                {booking &&
                                                                    format(new Date(date), "MM-dd-yyyy")}
                                                            </p>
                                                        </div>
                                                        <div className="flex gap-2 items-start ">
                                                            <p className="  font-semibold min-w-28">
                                                                Note Detail:
                                                                <span className=" text-gray-500 text-sm font-normal ml-2">
                                                                    {note}
                                                                </span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                                {/* Payment dates card */}
                                <div className=" bg-white p-5 rounded-xl">
                                    <div>
                                        <p className="font-semibold text-lg">Payment Dates </p>
                                        <p className="text-primary-red text-xs mb-1 mt-4 px-3">
                                            {booking && booking.pendingamount === 0
                                                ? "Package Full Payment"
                                                : "Package 50% Payment"}
                                        </p>
                                        <div className="flex justify-between items-center bg-p-gray p-3 rounded-xl h-[63px]">
                                            <p className="flex flex-row gap-2 items-center">
                                                <img src={checkBox} className="w-4 h-4" />
                                                {booking &&
                                                    format(new Date(booking?.created_at), "MM-dd-yyyy")}
                                            </p>
                                            <p className="font-semibold text-gray-500">
                                                {booking && booking.pendingamount === 0
                                                    ?
                                                    `${fmt(centsToDollors(booking?.first_amount))}`
                                                    : booking &&
                                                    `${fmt(centsToDollors(booking?.first_amount))}`}
                                            </p>
                                        </div>
                                        {booking && booking.pendingamount !== 0 && (
                                            <div>
                                                <p className="text-primary-red text-xs mb-1 mt-4 px-3">
                                                    Package Remaining Payment
                                                </p>
                                                <div className="flex justify-between bg-p-gray p-3 rounded-xl h-[63px]">
                                                    <p className="flex flex-row gap-2 items-center">
                                                        <img src={checkBox} className="w-4 h-4" />
                                                        {booking &&
                                                            format(
                                                                new Date(booking.second_payment_due_date).setDate(
                                                                    new Date(booking.second_payment_due_date).getDate()
                                                                ),
                                                                "MM-dd-yyyy"
                                                            )}{" "}
                                                    </p>
                                                    <p className="font-semibold text-gray-500">
                                                        <p
                                                            className="font-semibold"
                                                            style={{ margin: "0px" }}
                                                        >
                                                            $
                                                            {booking &&
                                                                roundUpPrice(booking?.pendingamount / 100)}
                                                        </p>
                                                    </p>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {/* Bartending Company Supplies */}
                                {booking?.package?.type === "custom_package" && (
                                    // booking?.customSupply.filter((i) => i.isbtcprovide).length > 0
                                    // &&
                                    <div className=" bg-white p-5 rounded-xl">
                                        <div>
                                            <p className="font-semibold text-lg">
                                                Bartending Company Provides{" "}
                                            </p>
                                            {booking?.package?.type === "custom_package" && booking && (
                                                <div className="flex justify-between">
                                                    <p>Number of Bartender</p>
                                                    <p className="text-gray-500">
                                                        {booking.bartenders.length}
                                                    </p>
                                                </div>
                                            )}
                                            {bartenderProvideAddons &&
                                                bartenderProvideAddons?.map(
                                                    (mandatoryAddon: any, i) => (
                                                        <>
                                                            <div
                                                                key={i}
                                                                className="flex justify-between items-center"
                                                            >
                                                                <p>{mandatoryAddon?.name ?? "-"}</p>
                                                            </div>
                                                        </>
                                                    )
                                                )}
                                            {booking?.package?.type === "custom_package" &&
                                                (booking.customSupply.filter(
                                                    (supply: any) => supply.isbtcprovide == true
                                                ).length > 0 ||
                                                    alcoholStatus.bartenderProvideAlcohol) &&
                                                booking?.customSupply.map((sup, i) => {
                                                    if (sup.isbtcprovide) {
                                                        return (
                                                            <div
                                                                key={i}
                                                                className="flex justify-between items-center"
                                                            >
                                                                <p>{sup.name}</p>
                                                                {/* <p className="font-semibold text-gray-500">${sup.price / 100}</p> */}
                                                            </div>
                                                        );
                                                    }
                                                })}
                                            {booking?.customAddons &&
                                                booking?.customAddons?.map((addon: any, i) => (
                                                    <>
                                                        <div
                                                            key={i}
                                                            className="flex justify-between items-center"
                                                        >
                                                            <p>{addon?.description ?? "-"}</p>
                                                        </div>
                                                    </>
                                                ))}
                                            {alcoholStatus.bartenderProvideAlcohol && (
                                                <div className="flex justify-between items-center">
                                                    <p>Alcohol</p>
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                )}
                                {/* Customer Supplies*/}
                                {booking?.package?.type === "custom_package" &&
                                    (booking.customSupply.filter(
                                        (supply: any) => supply.isbtcprovide == false
                                    ).length > 0 ||
                                        customerProvideAddons.length > 0 ||
                                        alcoholStatus.customerProvideAlcohol) && (
                                        // booking?.customSupply.filter((i) => !i.isbtcprovide).length > 0 &&
                                        <div className=" bg-white p-5 rounded-xl">
                                            <div>
                                                <p className="font-semibold text-lg">
                                                    Client Provides
                                                    {alcoholStatus.customerProvideAlcohol}
                                                </p>
                                                {customerProvideAddons &&
                                                    customerProvideAddons?.map(
                                                        (mandatoryAddon: any, i) => (
                                                            <>
                                                                <div
                                                                    key={i}
                                                                    className="flex justify-between items-center"
                                                                >
                                                                    <p>
                                                                        {mandatoryAddon?.name == "Portable Bar"
                                                                            ? "Bar Setup"
                                                                            : mandatoryAddon?.name ?? "-"}
                                                                    </p>
                                                                </div>
                                                            </>
                                                        )
                                                    )}
                                                {booking?.customSupply.map((sup, i) => {
                                                    if (!sup.isbtcprovide) {
                                                        return (
                                                            <div
                                                                key={i}
                                                                className="flex justify-between items-center"
                                                            >
                                                                <p>{sup.name}</p>
                                                                {/* <p className="font-semibold text-gray-500">${sup.price / 100}</p> */}
                                                            </div>
                                                        );
                                                    }
                                                })}
                                                {alcoholStatus.customerProvideAlcohol && (
                                                    <div className="flex justify-between items-center">
                                                        <p>Alcohol</p>
                                                    </div>
                                                )}
                                                <div></div>
                                            </div>
                                        </div>
                                    )}
                                {/* Total Cost */}
                                <div className="  p-5 rounded-xl  text-white bg-black">
                                    <div className="flex flex-col gap-1  ">
                                        <p className="font-semibold text-lg">
                                            Total Event Cost{" "}
                                        </p>
                                        <div className="flex font-semibold justify-between items-center text-sm px-3 mt-5">
                                            <p className="">Total Package </p>
                                            <p className="font-semibold text-gray-400">
                                                {fmt(centsToDollors(Number((booking?.service_total) + booking?.tips_total)))}
                                                {/* $
                                                {booking && booking.discount_total !== 0
                                                    ? USFormatePriceWithDecimal(
                                                        roundUpPrice(
                                                            (booking.service_total -
                                                                booking.discount_total) /
                                                            100
                                                        )
                                                    )
                                                    : booking &&
                                                    USFormatePriceWithDecimal(
                                                        roundUpPrice(booking.service_total / 100)
                                                    )}{" "} */}
                                            </p>
                                        </div>
                                        {booking?.max_estimated_alcohol ? (
                                            <div className="flex font-semibold justify-between items-center text-sm px-3  mb-5">
                                                <p className="text-white ">Alcohol Cost</p>
                                                <p className="font-semibold text-gray-400">
                                                    {fmt(centsToDollors(Number((booking?.max_estimated_alcohol) + (booking?.max_estimated_alcohol * 0.10))))}
                                                    {/* ${roundUpPrice(booking.producttotal / 100)} */}
                                                </p>
                                            </div>
                                        ) : (
                                            ""
                                        )}
                                        <div className="flex font-semibold justify-between items-center bg-white py-2 px-4 rounded-2xl h-[63px]">
                                            <p className="text-black ">Total Cost </p>
                                            <p className={` text-lg text-gray-400 `}>
                                                {fmt(centsToDollors(Number((booking?.service_total) + (booking?.tips_total)) + Number((booking?.max_estimated_alcohol) + (booking?.max_estimated_alcohol * 0.10))))}
                                                {/* $
                                                {booking && booking.discount_total !== 0
                                                    ? USFormatePriceWithDecimal(
                                                        roundUpPrice(
                                                            booking.producttotal / 100 -
                                                            booking.discount_total / 100 +
                                                            booking.service_total / 100
                                                        )
                                                    )
                                                    : booking &&
                                                    USFormatePriceWithDecimal(
                                                        roundUpPrice(
                                                            booking.producttotal / 100 +
                                                            booking.service_total / 100
                                                        )
                                                    )}{" "} */}
                                            </p>
                                        </div>
                                        <p className="text-white  mt-1 px-3 text-xs">
                                            This works out to be total event cost.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ) : (
                        <p className="text-gray-500 text-center">No booking found</p>
                    )}
                </>
            ) : (
                <div>
                    <Loader color="bg-red-400" />
                </div>
            )}
        </section>
    );
};

const roundUpPrice = (price: number) => {
    const decimalPlaces = 2;
    const factor = Math.pow(10, decimalPlaces);
    const roundedUp = Math.ceil(price * factor) / factor;
    return roundedUp?.toFixed(2);
};

export function calculateFirstHalfPayment(
    service_total: number,
    platFormFee: number,
    coupon = 0 // TypeScript will infer the type as number from the default value
) {
    const t = service_total - platFormFee - coupon; // coupon will be 0 if nothing is provided
    const dueToday = Math.ceil(t / 2);
    return dueToday + platFormFee;
}

interface CustomInfoIconProps {
    message: string;
    iconColor?: string;
    messageWidth?: string;
}

export default function IButton(
    {
        message,
        iconColor = "currentColor",
        messageWidth = "250px",
    }: CustomInfoIconProps = {
            message: "This is a custom info message.",
            iconColor: "currentColor",
            messageWidth: "250px",
        }
) {
    const [isOpen, setIsOpen] = useState(false);
    const iconRef = useRef<SVGSVGElement>(null);
    const messageRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                isOpen &&
                iconRef.current &&
                !iconRef.current.contains(event.target as Node) &&
                messageRef.current &&
                !messageRef.current.contains(event.target as Node)
            ) {
                setIsOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [isOpen]);

    const toggleMessage = () => {
        setIsOpen(!isOpen);
    };
    return (
        <div className=" inline-block">
            <svg
                ref={iconRef}
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="none"
                stroke={iconColor}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="w-4 h-4 cursor-pointer"
                onClick={toggleMessage}
                role="button"
                aria-label="Toggle information"
                tabIndex={0}
            >
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="16" x2="12" y2="12" />
                <line x1="12" y1="8" x2="12.01" y2="8" />
            </svg>
            {isOpen && (
                <div
                    ref={messageRef}
                    className="absolute p-4 mt-2 bg-white rounded-lg shadow-lg z-20"
                    style={{
                        width: messageWidth,
                        left: "50%",
                        transform: "translateX(-50%)",
                    }}
                >
                    <p className="text-sm text-gray-400 ">{message}</p>
                </div>
            )}
        </div>
    );
}

export function getNumberOfHours(
    startTime: Date | string,
    endTime: Date | string
) {
    return Math.ceil(
        (toDate(endTime).getTime() - toDate(startTime).getTime()) / (1000 * 3600)
    );
}

function Row({ label, value }: { label: string; value: string }) {
    return (
        <div className="flex items-center justify-between text-[12px] font-[400]">
            <span className="text-gray-600">{label}</span>
            <span className="text-gray-800">{value}</span>
        </div>
    );
}
